var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 66,
    viewBox: "0 0 100 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 66,
    rx: 33,
    fill: "url(#paint0_linear_52_63066)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4781 25C42.898 22.5315 46.2702 21 50.0001 21C53.7299 21 57.1021 22.5315 59.522 25M55.963 29C54.4981 27.3633 52.3694 26.3333 50 26.3333C47.6307 26.3333 45.5019 27.3633 44.0371 29M50 39.6667C52.0139 39.6667 53.9477 40.0101 55.7458 40.6417C55.8056 40.6627 55.8355 40.6732 55.8827 40.694C56.3101 40.8823 56.6383 41.3455 56.6744 41.8112C56.6784 41.8626 56.6784 41.9081 56.6784 41.9992C56.6784 42.3095 56.6784 42.4647 56.6913 42.5954C56.8162 43.8609 57.8174 44.8621 59.083 44.9871C59.2137 45 59.3689 45 59.6792 45H60.0058C60.6199 45 60.9269 45 61.1823 44.9497C62.2438 44.7404 63.0737 43.9106 63.2829 42.8491C63.3333 42.5937 63.3333 42.2866 63.3333 41.6725V41.4083C63.3333 40.7746 63.3333 40.4578 63.2656 40.0946C63.1143 39.2825 62.5243 38.2777 61.8888 37.7499C61.6046 37.5139 61.4118 37.4064 61.0264 37.1914C57.7627 35.3707 54.0025 34.3333 50 34.3333C45.9975 34.3333 42.2373 35.3707 38.9736 37.1914C38.5881 37.4064 38.3954 37.5139 38.1112 37.7499C37.4756 38.2777 36.8856 39.2825 36.7343 40.0946C36.6666 40.4578 36.6666 40.7746 36.6666 41.4083V41.6725C36.6666 42.2866 36.6666 42.5937 36.717 42.8491C36.9262 43.9106 37.7561 44.7404 38.8176 44.9497C39.073 45 39.38 45 39.9941 45H40.3207C40.6311 45 40.7862 45 40.9169 44.9871C42.1825 44.8621 43.1837 43.8609 43.3087 42.5954C43.3216 42.4647 43.3216 42.3095 43.3216 41.9992C43.3216 41.9081 43.3216 41.8626 43.3255 41.8112C43.3616 41.3455 43.6898 40.8823 44.1173 40.694C44.1644 40.6732 44.1943 40.6627 44.2541 40.6417C46.0522 40.0101 47.986 39.6667 50 39.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_63066",
    x1: 5.63371e-7,
    y1: 21,
    x2: 94,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6240"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIc);
export default __webpack_public_path__ + "static/media/call_ic.adf20afd.svg";
export { ForwardRef as ReactComponent };